/**
 * Dashboard Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const dashboardAPI = {
  getOverview: (params) => apiClient.get('/dashboard/overview', { params }),
  getDailySpending: (params) => apiClient.get('/dashboard/daily-spending', { params }),
  getSpendingByCategory: (params) => apiClient.get('/dashboard/spending-by-category', { params }),
  getRecentTransactions: (params) => apiClient.get('/dashboard/recent-transactions', { params }),
  getMonthlyTrends: (params) => apiClient.get('/dashboard/monthly-trends', { params }),
  getBudgetPerformance: (params) => apiClient.get('/dashboard/budget-performance', { params }),
  getNetWorth: (params) => apiClient.get('/dashboard/net-worth', { params }),
};

export default dashboardAPI;

